import WorkoutNotification from './WorkoutNotification';

export default WorkoutNotification;
